{
  "valid": "Gültig",
  "expired": "Abgelaufenes Zertifikat",
  "month": "{n} Monat | {n} Monate",
  "days": "{n} Tag übrig | {n} Tage übrig",
  "keystore": {
    "generateSelfSignedCertificate": "Selbstsigniertes Zertifikat generieren",
    "generateCSR": "CSR generieren",
    "csrRequiresUploadCertificate": "Für diese Zertifikatsignieranfrage muss ein Zertifikat hochgeladen werden",
    "list": {
      "action": {
        "delete": {
          "description": "Das Zertifikat {alias} wird gelöscht."
        }
      }
    },
    "updateCertificate": "Zertifikat aktualisieren",
    "csr": "CSR",
    "certificate": "Zertifikat",
    "error": {
      "csr": {
        "loading": "Fehler beim Laden der CSR"
      }
    },
    "automaticRenewal": {
      "label": "Automatische Zertifikatsverlängerung",
      "csr": {
        "info": "Die automatische Verlängerung wird täglich ausgeführt, wenn eine PKI-Parametrierung mit diesem Zertifikat verknüpft ist. Sie können die Verlängerung auch sofort auslösen, indem Sie auf die Schaltfläche drücken.",
        "buttonLabel": "Zertifikat generieren"
      }
    },
    "filters": {
      "searchByAlias": "Nach Alias suchen"
    }
  },
  "download": "Zertifikat herunterladen",
  "delete": "Zertifikat löschen",
  "noCertificate": "Kein Zertifikat verfügbar",
  "tag": "Tag",
  "tags": {
    "label": "Tags",
    "empty": "Kein Tag gefunden"
  },
  "alias": "Alias",
  "expiration": {
    "timestamp": {
      "label": "Ablaufdatum",
      "labelColon": "Ablaufdatum:"
    }
  },
  "list": {
    "column": {
      "timestamp": {
        "format": "YYYY-MM-DD um hh:mm A"
      }
    },
    "action": {
      "delete": {
        "description": "Das Zertifikat {alias} wird gelöscht."
      }
    }
  },
  "form": {
    "serialNumber": "Seriennummer",
    "organizationUnit": "Organisationseinheit",
    "organization": "Organisation",
    "locality": "Ort",
    "region": "Region",
    "country": "Land",
    "tags": {
      "placeholder": "Auswählen",
      "remove": {
        "tooltip": "Klicken, um das Tag zu entfernen"
      }
    },
    "associatedPkiConfiguration": "Zugehörige PKI-Parametrierung",
    "cn": "CN",
    "email": "E-Mail"
  },
  "validation": {
    "alias": {
      "required": "Der Alias ist erforderlich.",
      "invalid": "Der Alias darf nur Kleinbuchstaben aus dem lateinischen Alphabet, Ziffern, Bindestriche, Unterstriche oder Leerzeichen enthalten."
    },
    "cn": "Der CN ist erforderlich.",
    "email": "Die E-Mail-Adresse ist erforderlich.",
    "certificate": {
      "invalid": "Das Zertifikat scheint nicht gültig zu sein.",
      "extension": "Das Zertifikat hat nicht die richtige Dateierweiterung.",
      "fileEmpty": "Die Zertifikatsdatei darf nicht leer sein.",
      "fileSize": "Die Zertifikatsdatei darf höchstens 750 MB groß sein."
    },
    "associatedPkiConfiguration": "Warnung: Die automatische Zertifikatsverlängerung wird nicht durchgeführt, solange das Zertifikat/CSR nicht mit einer PKI-Parametrierung verknüpft ist."
  },
  "error": {
    "certificate": {
      "loading": "Fehler beim Laden des Zertifikats"
    }
  },
  "truststore": {
    "uploadCertificate": "Zertifikat hochladen",
    "editCertificate": "Zertifikat bearbeiten"
  },
  "filters": {
    "searchByAlias": "Nach Alias suchen"
  },
  "cancelAction": {
    "confirm": {
      "message": "Bestätigen Sie den Abbruch des Vorgangs? Alle Daten gehen verloren."
    }
  },
  "chain": {
    "label": "Zertifikatskette",
    "level": "Stufe {level}"
  },
  "downloadCSR": "CSR herunterladen",
  "subject": {
    "label": "Betreff"
  },
  "subjectAlternativeName": {
    "label": "Alternativer Antragstellername",
    "add": "SAN hinzufügen",
    "empty": "Es ist kein SAN definiert.",
    "delete": "SAN löschen",
    "noValue": "Fehlender Wert",
    "unknownError": "Während der Verifizierung ist ein unbekannter Fehler aufgetreten",
    "type": "Typ",
    "value": "Wert",
    "2": {
      "label": "DNS",
      "labelColon": "DNS:",
      "invalidFormat": "Der Wert muss ein gültiger DNS-Name sein"
    },
    "7": {
      "label": "IP",
      "labelColon": "IP",
      "invalidFormat": "Der Wert muss eine gültige IP-Adresse sein"
    }
  },
  "extendedKeyUsage": {
    "label": "Erweiterte Schlüsselverwendung",
    "empty": "Es ist keine erweiterte Schlüsselverwendung definiert.",
    "1": "Serverauthentifizierung",
    "2": "Clientauthentifizierung"
  },
  "tab": {
    "keystore": "Keystore",
    "truststore": "Truststore"
  },
  "trustChain": {
    "label": "Vertrauenskette"
  },
  "start": {
    "timestamp": {
      "labelColon": "Startdatum der Gültigkeit:"
    }
  }
}
